import { Component, OnInit, Input, forwardRef, EventEmitter, Output } from '@angular/core';
import {  FormControl } from '@angular/forms';

@Component({
  selector: 'form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss']
})
export class FormSelectComponent {

  public selectedValue = '';
  public disabled = false;
  
  public value: string;

  @Input()
  label: string;

  @Input()
  formCtrl: FormControl;

  @Input()
  pipe: { type?: string; params?: any };

  @Input()
  options: {key: string, label: string}[] = [];

  @Input()
  customId: string;

  @Input()
  placeholder: string;

  @Output() onChange = new EventEmitter<any>();

  
  public expanded = false;

  public activeItemIndex: number;

  showOptions() {
    if (!this.disabled) {
      this.expanded = !this.expanded;
    }
  }

  selectItem(item: {key: string, label: string}) {
    this.formCtrl.setValue(item.key);
    this.expanded = false;
    this.selectedValue = item.label;
    this.onChange.emit(this.formCtrl)
  }
}